/** GERP STYLE MASTER 가격 변경(128) — 레거시 appr_edit_forms_pricechange_mstr */
export const STYLE_MASTER_PRICE_TYPE = 128;

export const isStyleMasterPriceType = (apvType: number): boolean =>
  apvType === STYLE_MASTER_PRICE_TYPE;

export const STYLE_MASTER_PRICE_MISSING_MESSAGE =
  '데이터를 로드하지 않았습니다. 조회 조건 선택 후 확인 버튼을 누르세요.';

/** GERP 미상신 결재 건 — 키는 GERP 응답 그대로 */
export type StyleMasterPriceCandidate = {
  sysId: string;
  aprvId: string;
  aprvTypcd: string;
  title?: string | null;
  docTit?: string | null;
};

type Value = string | number | null | undefined;

/** GERP 128 본문 행 — 키는 GERP 응답 그대로 */
export type StyleMasterPriceRow = {
  brandNm?: Value;
  season?: Value;
  classLevel1Nm?: Value;
  styleNo?: Value;
  styleNameKo?: Value;
  /** FSTYLE_PRICE1 — 요청가 */
  priceUnitKrw?: Value;
  /** FSTYLE_PRICE — 현재 마스터가 */
  unitAfKrw?: Value;
  priceUnitCny?: Value;
  unitAfCny?: Value;
  modCont?: Value;
};

export type StyleMasterPriceDraftSource = {
  code: number;
  attributes: Record<string, unknown>;
  display: {
    candidates: StyleMasterPriceCandidate[] | null;
    selection: string[] | null;
    subject: string | null;
    content: { rows?: StyleMasterPriceRow[] | null } | null;
  };
};

/** 작성 중 고른 건 1개 */
export type StyleMasterPriceItem = {
  /** GERP 결재 건(ESGMSTR.APRV_ID) — 부분 반려 itemId */
  aprvId: string;
  /** 레거시 data-style_no — 건 제목(DOC_TIT) */
  styleNo: string;
  rows: StyleMasterPriceRow[];
};

/** 저장 attributes 와 같은 모양 */
export type StyleMasterPriceState = {
  systemId: string;
  approvalTypeCode: string;
  /** 고른 건, 쉼표로 이음 */
  approvalId: string;
  /** 작성 시점 표 HTML */
  content: string;
};

/** 레거시 콤보 문구 — 건 제목(DOC_TIT) */
export const buildStyleMasterPriceLabel = (c: StyleMasterPriceCandidate) =>
  c.docTit?.trim() || c.title?.trim() || c.aprvId;

/** 레거시 change_title_content — 고른 순서의 첫 건 기준 */
export const buildStyleMasterPriceSubject = (
  styleNos: string[],
  t: (key: string, options?: Record<string, unknown>) => string,
): string => {
  if (!styleNos.length) return '';
  const [first] = styleNos;
  if (styleNos.length === 1)
    return t('STYLE MASTER 가격 변경({{styleNo}})', { styleNo: first });
  return t('STYLE MASTER 가격 변경({{styleNo}} 외 {{count}}건)', {
    styleNo: first,
    count: styleNos.length - 1,
  });
};

/** 레거시 본문 — 고를 때마다 덮어씀 */
export const buildStyleMasterPriceEditorContent = (
  styleNos: string[],
  t: (key: string) => string,
): string =>
  `<p>&nbsp;</p><p>${t('추가')} : ${styleNos.join(
    ',',
  )}&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>`;

const nonEmpty = (v: unknown): string | null =>
  typeof v === 'string' && v.trim() ? v : null;

export const parseStyleMasterPriceAttributes = (
  attributes: Record<string, unknown> | null | undefined,
): StyleMasterPriceState | null => {
  const content = nonEmpty(attributes?.content);
  if (!attributes || !content) return null;
  return {
    systemId: nonEmpty(attributes.systemId) ?? '',
    approvalTypeCode: nonEmpty(attributes.approvalTypeCode) ?? '',
    approvalId: nonEmpty(attributes.approvalId) ?? '',
    content,
  };
};

export const parseStyleMasterPriceContent = (
  attributes: Record<string, unknown> | null | undefined,
): string | null => nonEmpty(attributes?.content);

export const buildStyleMasterPriceAttributes = (
  state: StyleMasterPriceState | null | undefined,
) =>
  state
    ? {
        systemId: state.systemId,
        approvalTypeCode: state.approvalTypeCode,
        approvalId: state.approvalId,
        content: state.content,
      }
    : null;

export const checkStyleMasterPriceBeforeSave = (
  state: StyleMasterPriceState | null | undefined,
): string | null =>
  state?.content && state.approvalId
    ? null
    : STYLE_MASTER_PRICE_MISSING_MESSAGE;

export const styleMasterPriceKey = (
  state: StyleMasterPriceState | null | undefined,
) => state?.approvalId ?? '';
